import React, { useEffect, useState, useContext } from 'react'
import { styled } from '@mui/material/styles'
import Layout from '@/product/components/templates/Layout'
import ListingTableView from '@/product/components/organisms/Product/TableView'
import { Button } from '@mui/material'
import ReportContext from '@/product/context/report/reportContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import { useFormik } from 'formik'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import PropTypes from 'prop-types'
import Tab from '@mui/material/Tab'
import AuctionContext from '@/product/context/auction/auctionContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import AlertContext from '@/product/context/alert/alertContext'
import {
    handleRedirectInternal,
    dateTimeFormatFunction,
} from '@/product/common/components'
import ImageEdit from '@/product/components/organisms/ImageEdit/index'
// import FieldHeader from './FieldHeader'
import CustomSearch from '../../components/molecules/CustomSearch'
import CustomTable from '../../components/molecules/CustomTable'
import SettingContext from '@/product/context/setting/settingContext'
import ScheduledPickupContext from '@/product/context/scheduledPickup/scheduledPickupContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import AllOrders from './Orders/allOrders'
const PREFIX = 'ERP'

const classes = {
    root: `${PREFIX}-root`,
}

const StyledLayout = styled(Layout)(({ theme }) => ({
    [`& .${classes.root}`]: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}))
function calculateRemainingTime2(startDate, endDate) {
    // Convert date strings to Date objects
    const startDateObj = new Date(startDate)
    const endDateObj = new Date(endDate)

    // Calculate the time difference in milliseconds
    const timeDiff = endDateObj.getTime() - startDateObj.getTime()

    // Convert time difference to days, hours, and minutes
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
    const hours = Math.floor(
        (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))

    // Determine the appropriate time unit to display
    if (days > 0) {
        return `${days} day${days > 1 ? 's' : ''}`.replace(/-/g, '')
    } else if (hours > 0) {
        return `${hours} hour${hours > 1 ? 's' : ''}`.replace(/-/g, '')
    } else {
        return `${minutes} minute${minutes > 1 ? 's' : ''}`.replace(/-/g, '')
    }
}

// Example usage

function TabPanel(props) {
    // const { children, value, index, ...other } = props
    // if (value == 0) {
    //     console.log(
    //         '9999999999999',
    //         value,
    //         index,
    //         value == index,
    //         value !== index
    //     )
    // }
    // return (
    //     <div
    //         role="tabpanel"
    //         hidden={value == 0 ? value !== index : false}
    //         id={`simple-tabpanel-${index}`}
    //         aria-labelledby={`simple-tab-${index}`}
    //         {...other}
    //     >
    //         {value == 0 ? value == index : true && <div>{children}</div>}
    //     </div>
    // )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}
function calculateRemainingTime(targetDate) {
    // Convert target date string to Date object
    const endDate = new Date(targetDate)

    // Get the current date
    const now = new Date()

    // Calculate the time difference in milliseconds
    const timeDiff = endDate.getTime() - now.getTime()

    // Convert time difference to days, hours, and minutes
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
    const hours = Math.floor(
        (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))

    // Determine the appropriate time unit to display
    if (days > 0) {
        return `${days} day${days > 1 ? 's' : ''}`.replace(/-/g, '')
    } else if (hours > 0) {
        return `${hours} hour${hours > 1 ? 's' : ''}`.replace(/-/g, '')
    } else {
        return `${minutes} minute${minutes > 1 ? 's' : ''}`.replace(/-/g, '')
    }
}

// Example usage

const Customer = (props) => {
    const settingcontext = useContext(SettingContext)
    const scheduledPickupContext = useContext(ScheduledPickupContext)
    const dynamicContext = useContext(DynamicContext)
    const alertContext = useContext(AlertContext)
    const { erp_tablefields, project_dynamicfields, propertyColumnReOrder } =
        dynamicContext
    const { setAlert } = alertContext
    const [tableBody, setTableBody] = useState([])
    const [value, setValue] = useState(0)
    const [tableValue, setTableValue] = useState([])
    const [changeStatus, setChangeStatus] = useState(false)
    const history = useHistory()
    const [custom, setCustom] = useState({})
    const [mainID, setMainID] = useState(0)
    const [isLoading, setIsLoading] = useState(true)
    const {
        getAllScheduledPickupUserData,
        all_scheduled_pickup_user,
        responseStatus,
        clearResponse,
        schedulePickupAction,
    } = scheduledPickupContext
    const toggleImageEditFullScreenPopup = (popup, id) => {}

    const [aucId, setAucId] = useState('')
    const [lotStatus, setLotStatus] = useState('draft')
    const toggleBulkImagePopup = (popup) => {
        setBulkImagePopup({ popup })
    }

    const onClickEdit = (id, secondaryID, type) => {
        setMainID(id)
        setChangeStatus(true)
    }

    const submitFunction = (id) => {
        let data = { id: mainID }
        data.schedule_status =
            value === 1
                ? 'waiting'
                : value === 2
                ? 'serving'
                : value === 3
                ? 'completed'
                : 'completed'
        data[
            value === 1
                ? 'waiting_date'
                : value === 2
                ? 'serving_date'
                : value === 3
                ? 'completed_date'
                : 'completed_date'
        ] = moment(
            dateTimeFormatFunction(new Date()),
            'MM-DD-YYYY h:mm a'
        ).format()

        schedulePickupAction(data)
    }

    const formik = useFormik({
        initialValues: {
            limit: 20,
            page: 1,
            orderby: '',
            slot: '',
            order: '',
            filters: {
                searchterm: {
                    type: 'like',
                    value: '',
                    field: 'u.first_name,u.last_name,u.email',
                },
            },
        },
        enableReinitialize: false,
        onSubmit: (values) => {
            setIsLoading(true)
            const currentDate = moment()
            if (values.slot == 'today') {
                values.year = false
                values.month = false
                values.week = false
                values.sameday = true
                const startTime = `${currentDate.format('MM-DD-YYYY')} 00:00 am`
                const endTime = `${currentDate.format('MM-DD-YYYY')} 23:59 pm`
                values.start_date = moment(
                    startTime,
                    'MM-DD-YYYY h:mm a'
                ).format()
                values.end_date = moment(endTime, 'MM-DD-YYYY h:mm a').format()
            } else if (values.slot == 'week') {
                values.year = false
                values.month = false
                values.week = true
                values.sameday = false
            } else if (values.slot == 'month') {
                values.year = false
                values.week = false
                values.month = currentDate.format('MM')
                values.sameday = false
            } else if (values.slot == 'year') {
                values.year = currentDate.format('YYYY')
                values.month = false
                values.week = false
                values.sameday = false
            } else {
                values.year = false
                values.month = false
                values.week = false
                values.sameday = false
            }
            getAllScheduledPickupUserData(values, 'main')
        },
    })
    useEffect(() => {
        formik.handleSubmit()
    }, [formik.values])

    useEffect(() => {
        if (
            all_scheduled_pickup_user &&
            all_scheduled_pickup_user.from == 'main'
        ) {
            if (
                all_scheduled_pickup_user.records &&
                all_scheduled_pickup_user.records.length
            ) {
                all_scheduled_pickup_user.records.map((data, index) => {
                    data.id = index
                })
                setTableBody(all_scheduled_pickup_user.records)
            } else {
                setTableBody([])
            }
            setIsLoading(false)
        }
    }, [all_scheduled_pickup_user])

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.status === 'success') {
                if (responseStatus.from == 'scheduledPickupAction') {
                    setAlert('Successfully Updated', responseStatus.status)
                    setMainID(0)
                    formik.handleSubmit()
                    setChangeStatus(false)
                }
            } else {
                setAlert(responseStatus.message, responseStatus.status)
            }
            clearResponse()
        }
    }, [responseStatus])

    const tableValues = [
        {
            field: 'first_name,last_name',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Name',
        },
        {
            field: 'phone',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Phone Number',
        },
        {
            field: 'email',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Email',
        },
        {
            field: 'visit_count',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Visit',
        },
        {
            field: 'booking_start_date',
            type: 'datetime',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Last Update',
        },
    ]

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        }
    }
    const searchInfo = [
        {
            label: 'Select',
            placeholder: 'All Time',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'select',
            name: 'slot',
            formik: formik,
            native: true,
            options: [
                {
                    show: 'Today',
                    value: 'today',
                },
                {
                    show: 'This Week',
                    value: 'week',
                },
                {
                    show: 'This Month',
                    value: 'month',
                },
                {
                    show: 'This Year',
                    value: 'year',
                },
            ],
        },
        {
            label: 'Search',
            placeholder: 'Search Customer Name / Email',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'searchterm',
            formik: formik,
            filter: true,
        },
    ]
    const changeChangeStatus = () => {
        setChangeStatus(false)
    }
    return (
        <>
            <div className="dashboard listing maillisting erpMisc">
                <div>
                    <CustomSearch searchInfo={searchInfo} formik={formik} />
                    <CustomTable
                        formik={formik.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={[]}
                        allData={all_scheduled_pickup_user}
                        isLoading={isLoading}
                        loadingTemplate={'table'}
                        changeTableFunction={getAllScheduledPickupUserData}
                        hideCompactView={true}
                    />
                </div>
                <CustomDialog
                    title={'Change Scheduled Pickup status'}
                    open={changeStatus}
                    function={changeChangeStatus}
                >
                    <h5>{`Are you sure you want to change the status from ${
                        value === 1
                            ? 'Booking'
                            : value === 2
                            ? 'Waitlist'
                            : value === 3
                            ? 'Serving'
                            : ''
                    } to ${
                        value === 1
                            ? 'Waitlist'
                            : value === 2
                            ? 'Serving'
                            : value === 3
                            ? 'Completed'
                            : ''
                    } `}</h5>
                    <div className="actionWrapper">
                        <Button
                            id="bidDeposit_cancel"
                            onClick={() => changeChangeStatus()}
                        >
                            Cancel
                        </Button>

                        <PrimaryButton
                            id="bidDeposit_submit"
                            onClick={() => submitFunction()}
                            label="Confirm"
                        />
                    </div>
                </CustomDialog>
            </div>
        </>
    )
}

export default Customer
